import { DEFAULT_LANGUAGE } from "src/app/constants";
import { Languages } from "src/app/enums";
import { Program } from "src/app/services/api";

const normalize = (raw: string | null | undefined): string | null => {
  if (!raw) return null;
  try {
    return new Intl.Locale(raw).language;
  } catch {
    return null;
  }
};

export const resolveLanguage = (candidate: string | null | undefined, program?: Program | null): Languages => {
  const enabled = program?.enabledLanguages?.map(l => l.toLowerCase());

  const candidateLang = normalize(candidate);
  if (candidateLang && (!enabled?.length || enabled.includes(candidateLang))) {
    return candidateLang as Languages;
  }

  const programDefault = normalize(program?.defaultLanguage);
  if (programDefault && enabled?.includes(programDefault)) {
    return programDefault as Languages;
  }

  return (enabled?.[0] ?? DEFAULT_LANGUAGE) as Languages;
};

export const resolveApiLanguage = (candidate: string | null | undefined, program?: Program | null): string => {
  const enabled = program?.enabledLanguages?.map(l => l.toLowerCase());

  const candidateLang = normalize(candidate);
  if (candidateLang && enabled?.includes(candidateLang)) {
    return candidateLang;
  }

  if (candidateLang && !enabled?.length) {
    return candidateLang;
  }

  const programDefault = normalize(program?.defaultLanguage);
  if (programDefault && enabled?.includes(programDefault)) {
    return programDefault;
  }

  return enabled?.[0] ?? DEFAULT_LANGUAGE;
};
